<template>
    <div>
        <nav class="navbar is-warning is-fixed-top" role="navigation">
            <div class="container ">
                <div class="navbar-brand">
                    <router-link class="navbar-item" to="/">
                        <img src="../../../assets/images/logo.png" alt="UltraShop.uz - Каждому по ноутбуку!" width="256"
                             height="48">
                    </router-link>
                    <div class="navbar-burger burger" data-target="navbarExampleTransparentExample">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                <div id="navbarExampleTransparentExample" class="navbar-menu">
                    <!--<div class="navbar-start">-->
                        <!--<div class="navbar-item is-hoverable">-->
                            <!--<a class="navbar-link">Брэнды</a>-->
                            <!--<div class="navbar-dropdown">-->
                                <!--<router-link v-for="brand in brands" :key="brand.id" class="navbar-item" :to="'/'+ brand.slug+'-noutbuki'">-->
                                    <!--{{brand.name}}-->
                                <!--</router-link>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="navbar-item has-dropdown is-hoverable">-->
                            <!--<a class="navbar-link">Категории</a>-->
                            <!--<div class="navbar-dropdown">-->
                                <!--<router-link v-for="type in laptopTypes" :key="type.id" class="navbar-item" :to="'/'+ type.slug">-->
                                    <!--{{type.name}}-->
                                <!--</router-link>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<router-link class="navbar-item" to="/contacts">Контакты</router-link>-->
                        <!--&lt;!&ndash;<a class="navbar-item">&ndash;&gt;-->
                            <!--&lt;!&ndash;<div class="fb-like" data-href="https://facebook.com/ultrashoptashkent" data-layout="button_count" data-action="like" data-size="large" data-show-faces="false" data-share="false"></div>&ndash;&gt;-->
                        <!--&lt;!&ndash;</a>&ndash;&gt;-->
                    <!--</div>-->
                    <div class="navbar-end">
                        <div class="navbar-item">
                            <a href="https://ultrashop.uz:8000/media/pricelist/ultrashop_pricelist_KpWEAiF.xlsx">
                                <button class="button is-danger">
                                    Прайслист
                                </button>
                            </a>
                        </div>
                        <div class="navbar-item">
                            <router-link to="/awaiting">
                                <button class="button is-danger">
                                    Под Заказ
                                </button>
                            </router-link>
                        </div>
                        <div class="navbar-item">
                            <router-link to="/sale">
                                <button class="button is-danger">
                                    Распродажа
                                </button>
                            </router-link>
                        </div>
                        <a class="navbar-item" href="tel: +998 98 128 58 72">
                            <img src="../../../assets/images/social/phone.png" width="16">
                            <span class=" has-text-weight-bold"> +998 98 128 58 72</span>
                        </a>
                        <a class="navbar-item" href="https://telegram.me/ultrashopuz" target="_blank">
                            <img src="../../../assets/images/social/telegram.png" width="16">
                            <span class=" has-text-weight-bold"> @ultrashopuz</span>
                        </a>
                    </div>
                </div>
            </div>
        </nav>
        <section class="section">
            <div class="container">
                <Search />
            </div>
        </section>
        <div id="fb-root"></div>
    </div>
</template>
<script>
    import Search from "../Search";

    export default {
        name: "Header",
        components: {Search},
        data() {
            return {
                brands: [],
                laptopTypes: [],
            }
        },
        // methods: {
        //     fetchBrands() {
        //         axios.get(API_URL + '/brand')
        //             .then(response => {
        //                 this.brands = response.data
        //             })
        //     },
        //     fetchLaptopTypes() {
        //         axios.get(API_URL + '/laptop-types')
        //             .then(response => {
        //                 this.laptopTypes = response.data
        //             })
        //     }
        // },
        created() {
            document.addEventListener('DOMContentLoaded', () => {

                // Get all "navbar-burger" elements
                const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

                // Check if there are any navbar burgers
                if ($navbarBurgers.length > 0) {

                    // Add a click event on each of them
                    $navbarBurgers.forEach(el => {
                        el.addEventListener('click', () => {

                            // Get the target from the "data-target" attribute
                            const target = el.dataset.target;
                            const $target = document.getElementById(target);

                            // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                            el.classList.toggle('is-active');
                            $target.classList.toggle('is-active');

                        });
                    });
                }

            })
            // (function(d, s, id) {
            //     var js, fjs = d.getElementsByTagName(s)[0];
            //     if (d.getElementById(id)) return;
            //     js = d.createElement(s); js.id = id;
            //     js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.1';
            //     fjs.parentNode.insertBefore(js, fjs);
            // }(document, 'script', 'facebook-jssdk'))
        }
    }
</script>
<style scoped>
    .navbar-item img {
        max-height: 256px;
    }
</style>
